"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.normalizeOrganizers = void 0;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var normalizeOrganizers = function normalizeOrganizers(organizers) {
  return organizers.reduce(function (acc, org) {
    var id = org.id,
        name = org.name,
        url = org.url,
        logo = org.logo,
        numUpcomingEvents = org.num_future_events,
        _org$follow_status = org.follow_status;
    _org$follow_status = _org$follow_status === void 0 ? {} : _org$follow_status;
    var followedByYou = _org$follow_status.followed_by_you,
        numFollowers = _org$follow_status.num_followers;
    var profilePicture = logo ? logo.url : undefined;
    return _objectSpread(_defineProperty({}, id, {
      id: id,
      name: name,
      url: url,
      profilePicture: profilePicture,
      followedByYou: followedByYou,
      numFollowers: numFollowers,
      numUpcomingEvents: numUpcomingEvents
    }), acc);
  }, {});
};

exports.normalizeOrganizers = normalizeOrganizers;
//# sourceMappingURL=transformations.js.map